// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Account Service Model
*/
export class AccountServiceModel {
    /**
    * @description Service Type Code
    */
    'serviceTypeCode'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AccountServiceModel>> = [
        {
            "name":     "serviceTypeCode",
            "baseName": "serviceTypeCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return AccountServiceModel.attributeTypeMap;
    }
}
